export default async function sendRequest(path, meth, options = {}) {
    let accesstoken = '';
    if (JSON.parse(localStorage.getItem(global.constants.const_localstorage_id) || '[]')[0] === undefined ||
        JSON.parse(localStorage.getItem(global.constants.const_localstorage_id) || '[]')[0].accesstoken === undefined) {
        accesstoken = global.constants.const_default_accesstoken;
    } else {
        accesstoken = JSON.parse(localStorage.getItem(global.constants.const_localstorage_id) || '[]')[0].accesstoken;
    }
    const headers = {
        ...(options.headers || {})
        , 'Content-type': 'application/json; charset=UTF-8'
        , 'Access-Control-Allow-Origin': '*'
    };
    var url = path+"?accesstoken="+accesstoken;
    const response = await fetch(url, {
        method: meth,
        mode: "cors",
        headers,
        ...options,
    });
    const data = await response.json();
    if (data.error) {
        throw new Error(data.error);
    }
    return data;
}